/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import handleFailedAuth from "../helpers/handleExpiredToken";
import { put, call, takeEvery, takeLatest } from "redux-saga/effects";
import {
  GET_ACCOUNTS,
  GET_ACCOUNTS_SUCCESS,
  GET_ACCOUNTS_FAILURE,
  ADD_ACCOUNT,
  ADD_ACCOUNT_SUCCESS,
  ADD_ACCOUNT_FAILURE,
  ADD_BANK_TO_ASSET,
  ADD_BANK_TO_ASSET_FAILURE,
  ADD_BANK_TO_ASSET_SUCCESS,
  REMOVE_BANK_FROM_ASSET,
  REMOVE_BANK_FROM_ASSET_SUCCESS,
  REMOVE_BANK_FROM_ASSET_FAILURE,
  REMOVE_ACCOUNT,
  REMOVE_ACCOUNT_SUCCESS,
  REMOVE_ACCOUNT_FAILURE,
  UNLINK_ASSETS,
  UNLINK_ASSETS_SUCCESS,
  UNLINK_ASSETS_FAILURE,
} from "../actions/actionTypes";
import { Account, AssetRequests } from "../api/agent";
import showToast from "../helpers/toastNotification";

function* getAccounts(action) {
  try {
    const payload = yield call(Account.getAccounts, action.payload);
    yield put({ type: GET_ACCOUNTS_SUCCESS, payload });
  } catch (err) {
    if (err.response.status === 401 || err.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = err.response.body;
    yield put({ type: GET_ACCOUNTS_FAILURE, errResp });
  }
}

export function* watchGetAccounts() {
  yield takeEvery(GET_ACCOUNTS, getAccounts);
}

function* addAccount(action) {
  try {
    const payload = yield call(Account.addAccount, action.payload);
    yield put({ type: ADD_ACCOUNT_SUCCESS, payload });
  } catch (err) {
    if (err.response.status === 401 || err.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = err.response.body;
    yield put({ type: ADD_ACCOUNT_FAILURE, errResp });
  }
}

export function* watchAddAccount() {
  yield takeEvery(ADD_ACCOUNT, addAccount);
}

function* addBankToAsset(action) {
  try {
    const payload = yield call(AssetRequests.addBankToAsset, action.payload);
    yield put({ type: ADD_BANK_TO_ASSET_SUCCESS, payload });
  } catch (err) {
    if (err.response.status === 401 || err.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = err.response.body;
    yield put({ type: ADD_BANK_TO_ASSET_FAILURE, errResp });
  }
}

export function* watchAddBankToAsset() {
  yield takeEvery(ADD_BANK_TO_ASSET, addBankToAsset);
}

function* removeBankFromAsset(action) {
  try {
    const payload = yield call(
      AssetRequests.removeBankFromAsset,
      action.payload
    );
    yield put({ type: REMOVE_BANK_FROM_ASSET_SUCCESS, payload });
  } catch (err) {
    if (err.response.status === 401 || err.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = err.response.body;
    yield put({ type: REMOVE_BANK_FROM_ASSET_FAILURE, errResp });
  }
}

export function* watchRemoveBankFromAsset() {
  yield takeEvery(REMOVE_BANK_FROM_ASSET, removeBankFromAsset);
}

function* removeAccount(action) {
  try {
    yield call(Account.deleteAccount, action.payload);
    yield put({ type: REMOVE_ACCOUNT_SUCCESS, payload: action.payload });
    showToast("s", "Account removed!");
  } catch (err) {
    if (err.response.status === 401 || err.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = err.response.body;
    yield put({ type: REMOVE_ACCOUNT_FAILURE, errResp });
  }
}

export function* watchRemoveAccount() {
  yield takeLatest(REMOVE_ACCOUNT, removeAccount);
}

function* unlinkAssets(action) {
  try {
    yield call(AssetRequests.unlinkAssets, action.payload);
    yield put({ type: UNLINK_ASSETS_SUCCESS, payload: action.payload });
  } catch (err) {
    if (err.response.status === 401 || err.response.statsCode === 401) {
      handleFailedAuth();
      return;
    }
    const errResp = err.response.body;
    yield put({ type: UNLINK_ASSETS_FAILURE, errResp });
  }
}

export function* watchUnlinkAssets() {
  yield takeLatest(UNLINK_ASSETS, unlinkAssets);
}
